var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"quiz_release_date"},[_vm._v("公開日 "+_vm._s(_vm.dateTime))])}
var staticRenderFns = []

export { render, staticRenderFns }